import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'एनडी';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
}

const eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['ई.पू.', 'AD'],
  wide: ['इसा पुर्व', 'अन्नो डोमिनी'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['पहिलो क्वाटर', 'दोस्रो क्वाटर', 'तेस्रो क्वाटर', 'चौथो क्वाटर'],
};

const monthValues = {
  narrow: ['J', 'एफ', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'जनवरी',
    'फेब्रुअरी',
    'मार्च',
    'अप्रिल',
    'सक्छ',
    'जुन',
    'जुलाई',
    'अगस्त',
    'सेप्टेम्बर',
    'अक्टुबर',
    'नोभेम्बर',
    'डिसेम्बर',
  ],
  wide: [
    'जनवरी',
    'फेब्रुअरी',
    'मार्च',
    'अप्रिल',
    'सक्छ',
    'जुन',
    'जुलाई',
    'अगस्त',
    'सेप्टेम्बर',
    'अक्टुबर',
    'नोभेम्बर',
    'डिसेम्बर',
  ],
};

const dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'एफ', 'S'],
  short: ['सु', 'मो', 'Tu', 'हामी', 'गु', 'फ्र', 'सा'],
  abbreviated: ['सूर्य', 'सोमबार', 'मंग', 'बुधवार', 'गु', 'शुक्र', 'शनि'],
  wide: [
    'आइतवार',
    'सोमबार',
    'मंगलबार',
    'बुधवार',
    'बिहीबार',
    'शुक्रवार',
    'शनिबार',
  ],
};

const dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'मील',
    noon: 'एन',
    morning: 'बिहान',
    afternoon: 'दिउँसो',
    evening: 'साँझ',
    night: 'रात',
  },
  abbreviated: {
    am: 'AM',
    pm: 'बेलुकी',
    midnight: 'मध्यरात',
    noon: 'दिउँसो',
    morning: 'बिहान',
    afternoon: 'दिउँसो',
    evening: 'साँझ',
    night: 'रात',
  },
  wide: {
    am: 'म',
    pm: 'बेलुका',
    midnight: 'मध्यरात',
    noon: 'दिउँसो',
    morning: 'बिहान',
    afternoon: 'दिउँसो',
    evening: 'साँझ',
    night: 'रात',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
